<template>
  <div>
    <div id="content" class="pay-page" v-if="isShowPage && photographerInfo">

        <div class="flex-between head-v">

          <div class="flex">
            <img src="../../assets/img/2234.svg" alt class="logoLogin" ondragstart="return false;" />
          </div>

          <button type="button" class="flex user-profile" aria-label="复制账号 ID" @click="copyPhotographerId">
            <img v-if="photographerInfo.avatar" class="user-img" :src="photographerInfo.avatar"/>
            <div class="user-nv">
              <div class="user-nv-name">{{photographerInfo.name || ''}}</div>
              <div class="user-nv-id">
                <span>ID: {{photographerInfo.id || ''}}</span>
                <svg viewBox="0 0 16 16" width="14" height="14" fill="none" stroke="currentColor" stroke-width="1.4" aria-hidden="true">
                  <rect x="5" y="2.5" width="8" height="9" rx="1.2" />
                  <path d="M3 5.5v7a1 1 0 0 0 1 1h6" />
                </svg>
              </div>
            </div>
          </button>
        </div>

        <div class='topDiv topDiv-w'>

          <div class="main-v">
            
            <div class="main-v-1">
              <div class="main-v-t">账号类型</div>

              <!-- <div class="main-v-m">{{vip_memo}}</div> -->
              <div class="main-v-m">{{vip_memo}}<span v-if="show_active" style="font-size: 12px;color: #EC4D3D; font-weight: bold">{{pricePromotionName()}}期间，视频+图片账号续期或新购立减 ¥ {{priceMoney(activeDiscountInfo.video_discount)}}/年。</span></div>

              <!-- <div class="main-v-m">当前为图片账号，不限存储空间，价格为¥299/年。双11期间，续期1年及以上免费升级为¥599/年的视频账号，视频账号将于11月底上线。</div> -->
            
              <!-- <div class="main-v-bv">
                <div class="main-v-btn-w" :class="vip_type == 1?'main-v-btn-1':''">图片</div>
              </div> -->

              <div class="main-v-bv">
                <button type="button" @click="vip_type == 2 ? changeVipType() : null" class="main-v-btn-w" :class="vip_type == 1 ? 'main-v-btn-1' : ''" :aria-pressed="vip_type == 1">图片账号</button>
                <button type="button" @click="vip_type == 1 ? changeVipType() : null" class="main-v-btn-w" :class="vip_type == 2 ? 'main-v-btn-1' : ''" :aria-pressed="vip_type == 2">视频+图片账号</button>
              </div>

            </div>

            <div class="main-v-1">
              <div class="main-v-t">协作席位（个）</div>
              <!-- <div class="main-v-m">{{sub_user_memo}}</div> -->
              <div class="main-v-m">{{sub_user_memo}}<span  v-if="show_active" style="font-size: 12px;color: #EC4D3D; font-weight: bold">{{pricePromotionName()}}期间，协作席位续期或新购立减 ¥ {{priceMoney(activeDiscountInfo.seat_discount)}}/年/席位。</span></div>
              <div class="flex-between main-v-nv">
                <div class="main-v-num">{{sub_count - 1 }}</div>
                <div class="flex">
                  <img v-if="sub_count > min_sub_count" @click="doReduceUser" class="main-v-add-img cursor-pointer" src="../../assets/img/reduce.svg"/>
                  <img v-else @click="notice1" class="main-v-add-img-1 cursor-pointer" src="../../assets/img/reduce.svg"/>
                  <img @click="doAddSubUser" class="main-v-add-img cursor-pointer m-l-30" src="../../assets/img/add.svg"/>
                </div>
              </div>
            </div>

            <div class="main-v-1">
              <div class="main-v-t">续期时长（年）</div>
              <!-- <div class="main-v-m">{{year_memo}}</div> -->
              <div class="main-v-m">{{year_memo}}<span  v-if="show_active" style="font-size: 12px;color: #EC4D3D; font-weight: bold">{{pricePromotionName()}}期间，每续期1年送{{activeDiscountInfo.gift_days}}天。</span></div>
            
              <div class="flex-between main-v-nv">
                <div class="main-v-num">{{year}}</div>
                <div class="flex">
                  <img v-if="year > min_year" @click="doReduceYear" class="main-v-add-img cursor-pointer" src="../../assets/img/reduce.svg"/>
                  <img v-else @click="notice2" class="main-v-add-img-1 cursor-pointer" src="../../assets/img/reduce.svg"/>
                  <img v-if="year < max_year" @click="doAddYear" class="main-v-add-img cursor-pointer m-l-30" src="../../assets/img/add.svg"/>
                  <img v-else @click="notice3" class="main-v-add-img-1 cursor-pointer m-l-30" src="../../assets/img/add.svg"/>
                </div>
              </div>
            </div>

            <div class="pad-btm-v"></div>
          </div>

        </div>


        <div class="bottomDiv flex-between">
          <div class="bottomDiv-w flex-between-w">
            <div class="pay-summary">
              <div>
                <div class="pay-summary-label">实付</div>
                <div v-if="hasDiscount" class="pay-summary-discount">{{pricePromotionName()}}优惠 · 已省 ¥ {{priceMoney(priceBreakdown.summary.discount_amt)}}</div>
              </div>
              <div class="pay-summary-amount">
                <span v-if="hasDiscount" class="pay-price-o">¥ {{original_amt}}</span>
                <span>¥ {{amt}}</span>
              </div>
            </div>
            <div class="pay-links">
              <button type="button" class="pay-link" @click="toHelp(99)">收费规则 &gt;</button>
              <button v-if="hasPayableAmount" type="button" class="pay-link" @click="openPriceDetail">价格明细 &gt;</button>
            </div>
            <button type="button" class="pay-btn" @click="doPay">立即支付</button>
          </div>
        </div>

      <div style="clear: both;"></div>

      <div v-if="showPriceDetail" class="price-detail-mask" @click.self="closePriceDetail">
        <div class="price-detail-drawer" @click.self="closePriceDetail" @touchmove.stop>
          <div class="price-detail-status">
            <div class="price-detail-status-label">付款后有效期</div>
            <div class="price-detail-expire">{{priceDetailExpireDate()}}</div>
            <div class="price-detail-benefit">
              {{priceRenewalDuration() === '未续期' ? '本次未续期' : '本次续期 ' + priceRenewalDuration()}}<span v-if="bonusDays > 0">，额外赠送 {{bonusDays}} 天有效期</span>
            </div>
            <div class="price-detail-status-meta">
              <div>账号类型<strong>{{vip_type == 2 ? '视频+图片账号' : '图片账号'}}</strong></div>
              <div>协作席位<strong>{{sub_count - 1}} 个</strong></div>
            </div>
          </div>

          <div class="price-detail-groups">
            <section v-for="group in pricePurchaseGroups()" :key="group.key" class="price-detail-group">
              <h3>{{group.name}}</h3>
              <div v-for="item in group.items" :key="item.name" class="price-detail-row">
                <span>{{priceItemFormula(item)}}</span><strong>¥ {{priceMoney(item.original_amount)}}</strong>
              </div>
            </section>
            <section v-if="priceDiscountSummaryItems().length" class="price-detail-group price-detail-discounts">
              <h3>{{pricePromotionName()}}优惠</h3>
              <div v-for="item in priceDiscountSummaryItems()" :key="item.name" class="price-detail-row">
                <span>{{item.name}}</span><strong>-¥ {{priceMoney(item.discount_amount)}}</strong>
              </div>
            </section>
            <section class="price-detail-total">
              <div>
                <h3>实付</h3>
                <p v-if="hasDiscount">{{pricePromotionName()}}优惠 · 已省 ¥ {{priceMoney(priceBreakdown.summary.discount_amt)}}</p>
              </div>
              <strong>¥ {{priceBreakdown ? priceMoney(priceBreakdown.summary.payable_amt) : '0.00'}}</strong>
            </section>
            <button type="button" class="pay-btn price-detail-pay" @click="doPay">立即支付</button>
          </div>
        </div>
      </div>

      <div  v-show="is_showQrcode" class="qrcode-bg" alt @click="closeQrcode"></div>
      
      <div v-show="is_showQrcode"  class="qrcode-v">
        
        <div class="qrcode-img">
          <div id="qrcode"></div>
        </div>

        <div class="qrcode-memo">使用微信扫码支付</div>
        <div class="qrcode-ref" @click="refreshQrcode">刷新二维码</div>

      </div>
    </div>

    <div v-else class="load-txt">
      <img src="../../assets/img/2234.svg" class="logoLogin2"/>
    </div>

    <!-- tip -->
    <transition name="el-zoom-in-top">
      <div class="generalTip1">
        <div class="generalTip"
            :class="tipType?'generalTip_b':'generalTip_r'" v-show="tipShow">
          <p>{{ tipMessage }}</p>
        </div>
      </div>
    </transition>

  </div>
</template>

<script>

//cnpm install qrcodejs2 --save
import { obtain } from "@/request/api";
import { Message } from "element-ui";
import { checkIsMobile , checkIsWexin, checkIsMiniApp, toHelp, toLogin ,formatDate,priceFormat } from "@/utils/common";
import wx from "weixin-js-sdk";
import { wxJsAuth, wxJsPay, wxH5Pay , wxQrCodePay, secretLogin, identity, grapherinfo, calcOrderAmt,getActiveDiscount } from "@/request/api";
import QRCode from 'qrcodejs2';
import Axios from "axios";

export default {
  name: "pay",
  data() {
    return {
      tipShow: false,
      tipType: false,
      tipMessage: "",

      isWexin:false,
      isMobile:false,

      code_url:'',
      is_showQrcode:0,

      isSubmiting: false,
      user_id: 0,
      photographer_id: 0,
      isShowPage: false,
      photographerInfo: null,

      year: 0,
      min_year: 0,
      max_year: 5,
      year_memo: '',

      sub_count: 1,
      min_sub_count: 1,
      sub_user_memo:'',

      is_expired: false,
      vip_type: 1,
      vip_memo:'',
      
      sub_price:'',
      vip1_price:'',
      vip2_price:'',

      amt: '0.00',
      original_amt: '0.00',
      activeSettingFlag: 0, //0：不在活动期间 1：预告期 2：活动期
      active_timer: null,
      show_active: 0,
      activeDiscountInfo: null,
      isActiveDiscountLoading: false,
      priceBreakdown: null,
      showPriceDetail: false,
    };
  },
  computed: {
    hasPayableAmount() {
      return parseFloat(String(this.amt).replace(/,/g, '')) > 0;
    },
    hasDiscount() {
      return this.original_amt != this.amt && this.priceBreakdown && Number(this.priceBreakdown.summary.discount_amt) > 0;
    },
    bonusDays() {
      return this.priceBreakdown && this.priceBreakdown.benefits ? Number(this.priceBreakdown.benefits.bonus_days || 0) : 0;
    },
  },
  /*
  watch: {
    year(newVal) {
      // 需求1：年限 >= 1 时，自动选中“升级为视频账号”
      if (newVal >= 1 && this.vip_type !== 2 && this.activeSettingFlag == 2) {
        this.vip_type = 2;
        if (this.min_year < 1) 
          this.min_year = 1;
        this.calcPayAmt();
      }
    }
  },*/
  mounted() {
    let that = this

    that.secret = this.$route.query.secret;
    console.log('pay-secret', that.secret);

    that.isWexin = checkIsWexin();
    that.isMobile = checkIsMobile();


    /*
    // 活动时间
    const start = new Date('2026-08-20').getTime();   // >=
    const end = new Date('2026-10-08').getTime();     // <
    const current = Date.now();
    console.log('current', current)
    if(current >= start && current < end)
    {
      that.show_active = 1;
    }
    */

    if(!that.secret)
    {
      /*
      //判断是否登录
      var access_token = window.localStorage.getItem("access_token");
      if(!access_token)
      {
        Message.error("非法请求！");
        that.toLogin();
      }
      else
      {
        //获取用户登录信息
        that.getUserIdentityInfo();
      }*/

      //获取用户登录信息
      that.getUserIdentityInfo();
    }
    else
    {
      //秘钥打开
      that.secretLogin()
    }

    // 固定页面本身，保留付款选项区和价格明细抽屉的内部滚动。
    document.body.style.overflow = 'hidden';
    document.body.style.position = 'fixed';
    document.body.style.width = '100%';
    document.body.style.height = '100%';

  },
  methods: {
    copyPhotographerId() {
      const id = String(this.photographerInfo && this.photographerInfo.id || '');
      if (!id) return;
      const done = () => {
        this.tipShow = true;
        this.tipType = true;
        this.tipMessage = '复制成功';
        setTimeout(() => { this.tipShow = false; }, 1000);
      };
      const fallback = () => {
        const input = document.createElement('textarea');
        input.value = id;
        input.setAttribute('readonly', '');
        input.style.position = 'fixed';
        input.style.opacity = '0';
        document.body.appendChild(input);
        input.select();
        try { document.execCommand('copy'); done(); }
        finally { document.body.removeChild(input); }
      };
      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(id).then(done).catch(fallback);
      } else {
        fallback();
      }
    },
    
    initWxConfig() {
      if (this._wxConfigPromise) return this._wxConfigPromise;
      const pending = wxJsAuth({ url: window.location.href.split('#')[0] }).then((res) => {
        const data = res && res.data && res.data.data;
        if (!res || res.status !== 200 || !data || !data.appId || !data.timestamp || !data.nonceStr || !data.signature) {
          throw new Error('wx_config_unavailable');
        }
        return new Promise((resolve, reject) => {
          const timer = setTimeout(() => reject(new Error('wx_config_timeout')), 15000);
          wx.error(() => { clearTimeout(timer); reject(new Error('wx_config_failed')); });
          wx.config({
            debug: false,
            appId: data.appId,
            timestamp: data.timestamp,
            nonceStr: data.nonceStr,
            signature: data.signature,
            jsApiList: ['checkJsApi', 'chooseWXPay']
          });
          wx.ready(() => { clearTimeout(timer); resolve(); });
        });
      }).catch((error) => {
        if (this._wxConfigPromise === pending) this._wxConfigPromise = null;
        throw error;
      });
      this._wxConfigPromise = pending;
      return pending;
    },
    secretLogin()
    {
      let that = this;
      
      let param = {
        code: that.secret,
        type: 2,
      };
      
      console.log('param',param)
      secretLogin(param).then((res) => {
        console.log('secretLogin',res)
        if (res.status == 200 && res.data.data && res.data.data.access_token)
        {
          window.localStorage.setItem(
            "access_token",
            JSON.stringify(res.data.data.access_token)
          );
          that.doGetActiveDiscount()
          that.getUserIdentityInfo()
        } 
        else 
        {
          //Message.error(res.data.message, "登录失败，请重新登录！");
          that.tipShow = true;
          that.tipType = false;
          that.tipMessage = res.data.message || "登录失败，请重新登录";
          setTimeout(() => {
            that.tipShow = false;
            that.toLogin();
          }, 1000);
        }
      })
    },
    getUserIdentityInfo()
    {
      let that = this
      identity().then((res) => {
      console.log("getUserIdentityInfo",res);
        if (res.data.data) {
          //已登录
          that.user_id = res.data.data.user_id
          that.photographer_id = res.data.data.photographer_id
          // Initialize only after login has established the request account scope.
          if (that.isWexin) that.initWxConfig().catch(() => {});

          that.getGrapherinfo()
          if (!that.isActiveDiscountLoading && !that.activeDiscountInfo) that.doGetActiveDiscount()
          /*
          that.active_timer = setInterval(() => {
              // 这里写你的定时器逻辑
              console.log('定时器执行');
              that.doGetActiveDiscount()
          }, 1000); // 1000毫秒后执行一次
          */
        } 
        else 
        {
          // Message.error("登录失败，请重新登录！");
          // that.toLogin();

          that.tipShow = true;
          that.tipType = false;
          that.tipMessage =  res.data.message || "登录失败，请重新登录";
          setTimeout(() => {
            that.tipShow = false;
            that.toLogin();
          }, 1000);
        }
      });
    },
    // 获取个人信息
    getGrapherinfo() 
    {
      let that = this
      let param = {
        photographer_id: that.photographer_id,
      };
      
      grapherinfo(param).then((res) => {
        console.log('getGrapherinfo',res)
        if (res.data.data) {
          that.photographerInfo = res.data.data
          if (that.activeDiscountInfo) {
            that.calcShowData()
            that.isShowPage = true
          }
         
        }
        else
        {
          // if(checkIsMiniApp())
          // {
          //   Message.error("获取用户失败，请重新进入小程序打开！");
          // }
          // else
          // {
          //   Message.error("获取用户信息失败，请重新登录！");
          // }

          that.tipShow = true;
          that.tipType = false;
          that.tipMessage =  res.data.message || "获取用户信息失败，请重新登录";
          setTimeout(() => {
            that.tipShow = false;
            that.toLogin();
          }, 1000);
          //that.toLogin()
        }
      });
    },
    // doCheckActiveSetting()
    // {
    //   let that = this
    //   let param = {
        
    //   };
      
    //   checkActiveSetting(param).then((res) => {
    //     console.log('checkActiveSetting',res.data)
    //     if (res.data && res.data.code == 200) {
    //       that.activeSettingFlag = res.data.data
    //     }
   
    //   });
    // },
    doGetActiveDiscount()
    {
      let that = this
      let param = {
        
      };
      
      that.isActiveDiscountLoading = true
      getActiveDiscount(param).then((res) => {
        that.isActiveDiscountLoading = false
        console.log('getActiveDiscount',res.data)
        if (res.data && res.data.code == 200) {
          that.activeDiscountInfo = res.data.data

          if(!that.activeDiscountInfo)
          {
            that.tipShow = true;
            that.tipType = false;
            that.tipMessage =  res.data.message || "获取价格信息失败";
            setTimeout(() => {
              that.tipShow = false;
              that.toLogin();
            }, 1000);
            return;
          }

          if(that.activeDiscountInfo.active_flag == 1)
          {
            that.show_active = 1;
          }

          that.sub_price = that.activeDiscountInfo.seat_price;
          that.vip1_price = that.activeDiscountInfo.image_price;
          that.vip2_price = that.activeDiscountInfo.video_price;

          if (that.photographerInfo) {
            that.calcShowData()
            that.isShowPage = true
          }
        }
        else
        {
          that.tipShow = true;
            that.tipType = false;
            that.tipMessage =  res.data.message || "获取价格信息失败";
            setTimeout(() => {
              that.tipShow = false;
              that.toLogin();
            }, 1000);
            return;
        }
   
      });
    },
    calcShowData()
    {
      let that = this
      //var vip_expiretime = '2024-11-20'
      var vip_expiretime = that.photographerInfo.vip_expiretime 
      var d1 = new Date(vip_expiretime.replace(/-/g, "/"));
      var d2 = new Date();
      var day_txt = formatDate(d1,false)

      if(d1 < d2)
      {
        that.is_expired = true;

        // 已到期
        // 文案：你的账号已到期，请按需选择续期时长。
        // 预设参数：1（且无法点击「-」号回到0）
        that.year_memo = '你的账号已到期，请及时续期。';
        that.year = 1;
        that.min_year = 1;
      }
      else
      {
        var diff = d1 - d2
        //var day = parseInt(diff/(24 * 60 * 60 * 1000));
        //大于30天
        if(diff > 30 * 24 * 60 * 60 * 1000)
        {
          // 距到期大于30天
          // 文案：你的账号将于2025/03/11到期，请按需选择续期时长。如果你希望在有效期内购买更多席位或升级音视频账号，请保持续期时长为0年。
          // 预设参数：0
          
          //that.year_memo = '你的账号将于' + day_txt + '到期，如果你想在有效期内增购席位或开通音视频权限，请保持续期时长为0年。'
          that.year_memo = '你的账号将于' + day_txt + '到期，如果你想在有效期内开通视频管理功能或增加席位，请保持续期时长为0年。'
          that.year = 0;
          that.min_year = 0;
        }
        else
        {
          // 距到期小于等于30天
          // 文案：你的账号即将到期，请按需选择续期时长。
          // 预设参数：1
          that.year_memo = '你的账号将于' + day_txt + '到期，请及时续期。'
          that.year = 1;
          that.min_year = 0;
        }
      }

      // that.is_expired = true;
      // that.photographerInfo.sub_user_limit  = 10;
      if(that.photographerInfo.sub_user_limit > 1)
      { 
        if(that.is_expired)
        {
          // 席位数>1 && 已到期
          // 文案：当前拥有10个席位，已使用8个。你可以购买更多席位与同事一起使用，价格为￥199.00/年/席位。
          // 预设参数：10
          that.sub_user_memo = '当前有'+ (that.photographerInfo.sub_user_limit - 1) +'个协作席位，增加席位后可以与更多同事一起使用，价格为￥' + that.sub_price + '/年/席位。'
          that.sub_count = that.photographerInfo.sub_user_limit;
          that.min_sub_count = 1;
        }
        else
        {
          //席位数>1 && 未到期
          //文案：当前拥有10个席位，已使用8个。你可以购买更多席位与同事一起使用，价格为￥199.00/年/席位，到期前购买系统会自动计算差价。
          //预设参数：10（且无法点击「-」号回到0，提示到期后才能减少席位）
          that.sub_user_memo = '当前有'+  (that.photographerInfo.sub_user_limit - 1) +'个协作席位，增加协作席位后可以与更多同事一起使用，价格为￥' + that.sub_price + '/年/席位。'
          that.sub_count = that.photographerInfo.sub_user_limit;
          //支持减少席位
          // that.min_sub_count = that.photographerInfo.sub_user_limit;
          that.min_sub_count = 1;
        }
        
      }
      else
      {
        if(that.is_expired)
        {
          // 席位数=1 && 已到期
          // 文案：当前拥有1个席位，只能通过你的微信登录使用。你可以购买更多席位与同事一起使用，价格为￥199.00/年/席位。
          // 预设参数：1
          that.sub_user_memo = '当前没有协作席位，你只能用自己的微信管理云作品。购买席位后，可以与同事一起使用，价格为￥' + that.sub_price + '/年/席位。'
          that.sub_count = 1;
          that.min_sub_count = 1;
        }
        else
        { 
          //席位数=1 && 未到期
          //文案：当前拥有1个席位，只能通过你的微信登录使用。你可以购买更多席位与同事一起使用，价格为￥199.00/年/席位，到期前购买系统会自动计算差价。
          //预设参数：1
          that.sub_user_memo = '当前没有协作席位，你只能用自己的微信管理云作品。购买席位后，可以与同事一起使用，价格为￥' + that.sub_price + '/年/席位。'
          that.sub_count = 1;
          that.min_sub_count = 1;
        }
      }    

      //that.photographerInfo.vip_type = 2;
      that.vip_type = that.photographerInfo.vip_type
      if(that.photographerInfo.vip_type == 1)
      {
        /*
        if(that.is_expired)
        {
          // 图片 && 已到期
          // 文案：当前账号支持管理图片内容，不限存储空间，价格为￥299.00/年。开通音视频权限后可管理音视频内容，不限存储空间，价格为￥699.00/年。
          // 预设参数：图片
          that.vip_memo = '当前为图片账号，不限存储空间，价格为￥' + that.vip1_price +'/年。可升级为视频+图片账号，不限存储空间，价格为￥' + that.vip2_price +'/年。'
        }
        else
        {
          //图片 && 未到期
          // 文案：当前账号支持管理图片内容，不限存储空间，价格为￥299.00/年。开通音视频权限后可管理音视频内容，不限存储空间，价格为￥699.00/年，到期前开通系统会自动计算差价。
          // 预设参数：图片
          that.vip_memo = '当前为图片账号，不限存储空间，价格为￥' + that.vip1_price +'/年。可升级为视频+图片账号，不限存储空间，价格为￥' + that.vip2_price +'/年。'
        }*/
        //that.vip_memo = '当前为图片账号，不限制存储空间，价格为¥299.00/年。';
      }
      else
      {

        // that.min_year = 0
        // that.year = 0

        // 音视频
        // 文案：当前账号支持管理图片和音视频内容，不限存储空间，价格为￥699.00/年。
        // 预设参数：音视频（且无法点击「图片」，提示不支持回退到仅支持图片）
        //that.vip_memo = '当前为视频+图片账号，不限存储空间，价格为￥' + that.vip2_price +'/年。'

        //that.vip_memo = '当前为视频+图片账号，不限制存储空间，价格为¥599.00/年，将于11月底上线。';
      }

      /*
      // 需求2：打开页面默认选中“升级为视频账号”
      if (that.vip_type !== 2) 
      {
        that.vip_type = 2;
        that.min_year = Math.max(that.min_year, 1);
        if (that.year < 1) {
          that.year = 1;
        }
      }*/

      that.showVipeMemo();

      // //加载完后，计算价格
      that.calcPayAmt()
    },
    doAddYear()
    {
      let that = this
      if(that.year >= that.max_year)
      {
        return;
      }

      that.year++;

      that.calcPayAmt()
    },
    doReduceYear()
    {
      let that = this

      if(that.year <= that.min_year)
      {
        return;
      }
      
      that.year--;

      that.calcPayAmt()
    },
    doAddSubUser()
    {
      let that = this
      // if(that.sub_count >= that.max_sub_count)
      // {
      //   return;
      // }

      that.sub_count++;

      that.calcPayAmt()
    },
    doReduceUser()
    {
      let that = this

      if(that.sub_count <= that.min_sub_count)
      {
        return;
      }
      
      that.sub_count--;

      that.calcPayAmt()
    },
    notice1()
    {
      let that = this
      if(that.sub_count <= 1)
      {
        return
      }

      /*
      if(that.is_expired != true)
      { 
        that.tipShow = true;
        that.tipType = false;
        that.tipMessage = "到期前不能减少席位";
        setTimeout(() => {
          that.tipShow = false;
        }, 1000);
      }*/
      return
    },
    notice2()
    {
      let that = this
      if(that.is_expired == true)
      { 
        that.tipShow = true;
        that.tipType = false;
        that.tipMessage = "账号已到期";
        setTimeout(() => {
          that.tipShow = false;
        }, 1000);
      }
      return
    },
    notice3()
    {
      let that = this
      that.tipShow = true;
      that.tipType = false;
      that.tipMessage = "最多续期5年";
      setTimeout(() => {
        that.tipShow = false;
      }, 1000);
    },
    changeVipType()
    {
      let that = this
      
      //音视频（且无法点击「图片」，提示不支持回退到仅支持图片）
      //需要支持回退
      /*
      if(that.photographerInfo.vip_type == 2)
      {
        if(that.vip_type == 2 && that.is_expired == false)
        {
          //Message.error("不支持回退");
          that.tipShow = true;
          that.tipType = false;
          that.tipMessage = "到期前不能回退";
          setTimeout(() => {
            that.tipShow = false;
          }, 1000);

          return
        }
      }*/

      if(that.vip_type == 1)
      {
        that.vip_type = 2
        // that.min_year = 1
        // if(that.year == 0)
        // {
        //   that.year = 1
         
        // }
      }
      else
      {
        that.vip_type = 1
        // that.year = 0
        // that.min_year = 0
        
      }

      that.showVipeMemo();
      that.calcPayAmt()
    },
    showVipeMemo()
    {
      let that = this
      if(that.photographerInfo.vip_type == 1)
      {
        if(that.vip_type == 2)
        {
          that.vip_memo = '可升级至视频+图片账号，不限制存储空间，价格为¥' + that.vip2_price + '/年。';
        }
        else
        {
          that.vip_memo = '当前为图片账号，不限制存储空间，价格为¥' + that.vip1_price + '/年。';
        }
      }

      if(that.photographerInfo.vip_type == 2)
      {
        if(that.vip_type == 1)
        {
          that.vip_memo = '可回退至图片账号，不限制存储空间，价格为¥' + that.vip1_price + '/年。';
        }
        else
        {
          that.vip_memo = '当前为视频+图片账号，不限制存储空间，价格为¥' + that.vip2_price + '/年。'
        }
      }
    },
    calcPayAmt()
    {
      const version = this._quoteVersion = (this._quoteVersion || 0) + 1
      let that = this
      let param = {
        year: that.year,
        sub_count: that.sub_count,
        vip_type: that.vip_type,
      };
      
      calcOrderAmt(param).then((res) => {
        if (this._isDestroyed || version !== this._quoteVersion) return;
        console.log('calcOrderAmt',res)
        if (res.data.data) 
        {
          //that.amt = res.data.data.amt
          var amt = res.data.data.amt
          that.amt = priceFormat(amt, 2);

          var original_amt =  res.data.data.original_amt
          that.original_amt = priceFormat(original_amt, 2);
          that.priceBreakdown = res.data.data.breakdown || null;
        }
        else
        {
          //Message.error(res.data.message || "计算金额失败");
          that.tipShow = true;
          that.tipType = false;
          that.tipMessage = res.data.message || "计算金额失败";
          setTimeout(() => {
            that.tipShow = false;
          }, 1000);
          
        }
      });
    },
    openPriceDetail() {
      if (this.hasPayableAmount) this.showPriceDetail = true;
    },
    closePriceDetail() {
      this.showPriceDetail = false;
    },
    priceMoney(value) {
      return priceFormat(Number(value || 0), 2);
    },
    priceDetailItems() {
      if (!this.priceBreakdown) return [];
      return [].concat(this.priceBreakdown.renewal_items || [], this.priceBreakdown.upgrade_items || []);
    },
    priceDiscountItems() {
      return this.priceDetailItems().filter(item => Number(item.discount_amount) > 0);
    },
    priceDiscountSummaryItems() {
      const discounts = { image: 0, video: 0, seats: 0 };
      this.priceDiscountItems().forEach(item => {
        const key = /席位/.test(item.name) ? 'seats' : /视频|图片和视频|视频\+图片/.test(item.name) ? 'video' : 'image';
        discounts[key] += Number(item.discount_amount || 0);
      });
      return [
        { key: 'image', name: '图片账号', discount_amount: discounts.image },
        { key: 'video', name: '视频+图片账号', discount_amount: discounts.video },
        { key: 'seats', name: '协作席位', discount_amount: discounts.seats },
      ].filter(item => item.discount_amount > 0);
    },
    priceFormulaDuration(days) {
      const years = Math.floor(Number(days || 0) / 365);
      const remainingDays = Number(days || 0) % 365;
      return years ? `${years}年${remainingDays ? `${remainingDays}天` : ''}` : `${remainingDays}天`;
    },
    priceDailyMoney(value) {
      return (Number(value || 0) / 365).toFixed(2);
    },
    priceRenewalDuration() {
      const years = this.priceBreakdown && this.priceBreakdown.benefits
        ? Number(this.priceBreakdown.benefits.renewal_years || 0)
        : Number(this.year || 0);
      return years ? `${years}年` : '未续期';
    },
    pricePurchaseGroups() {
      const account = { key: 'account', name: this.vip_type == 2 ? '视频+图片账号' : '图片账号', items: [] };
      const seats = { key: 'seats', name: '协作席位', items: [] };
      this.priceDetailItems().forEach(item => {
        (Number(item.seat_count) > 0 || /席位/.test(item.name) ? seats : account).items.push(item);
      });
      return [account, seats].filter(group => group.items.length);
    },
    priceItemFormula(item) {
      const isSeat = Number(item.seat_count) > 0 || /席位/.test(item.name);
      if (item.remaining_days) {
        const annualPrice = isSeat ? item.original_annual_price : item.original_annual_difference;
        return `补差 · ¥${this.priceDailyMoney(annualPrice)}${isSeat ? `/天/席位 × ${item.seat_count}席位` : '/天'} × ${this.priceFormulaDuration(item.remaining_days)}`;
      }
      const years = Number(item.years || item.quantity || 0);
      return `续期 · ¥${this.priceMoney(item.original_unit_price)}${isSeat ? `/年/席位 × ${item.seat_count}席位 × ` : '/年 × '}${years}年`;
    },
    pricePromotionName() {
      return this.priceBreakdown && this.priceBreakdown.promotion && this.priceBreakdown.promotion.name
        || this.activeDiscountInfo && this.activeDiscountInfo.active_name
        || '活动';
    },
    priceDetailExpireDate() {
      let expire = this.photographerInfo && this.photographerInfo.vip_expiretime
        ? new Date(this.photographerInfo.vip_expiretime.replace(/-/g, '/')) : new Date();
      const now = new Date();
      if (expire < now) expire = now;
      expire.setFullYear(expire.getFullYear() + Number(this.year || 0));
      expire.setDate(expire.getDate() + this.bonusDays);
      return formatDate(expire, true);
    },
    doPay()
    {
      let that = this

      /*
      if(that.vip_type == 2)
      {
        // if(that.activeSettingFlag == 1)
        // {
        //   //Message.error("支付金额必须大于0元");
        //   that.tipShow = true;
        //   that.tipType = false;
        //   that.tipMessage = "活动即将开始";
        //   setTimeout(() => {
        //     that.tipShow = false;
        //   }, 1000);

        //   return
        // }

        // if(that.activeSettingFlag == 0)
        // {
        //   //Message.error("支付金额必须大于0元");
        //   that.tipShow = true;
        //   that.tipType = false;
        //   that.tipMessage = "请联系使用顾问购买";
        //   setTimeout(() => {
        //     that.tipShow = false;
        //   }, 1000);

        //   return
        // }

        that.tipShow = true;
          that.tipType = false;
          that.tipMessage = "敬请期待";
          setTimeout(() => {
            that.tipShow = false;
          }, 1000);

          return
      }*/

      if(that.amt <= 0)
      {
        //Message.error("支付金额必须大于0元");
        that.tipShow = true;
        that.tipType = false;
        that.tipMessage = "支付金额必须大于0元";
        setTimeout(() => {
          that.tipShow = false;
        }, 1000);

        return
      }

      // that.doWxH5Pay();
      // return;
      if(that.isMobile)
      {
        if(that.isWexin)
        {
          that.doWxJsPay();
        }
        else
        {
          Message.error("目前仅支持微信支付，请复制到微信中打开");
        }
        
      }
      else
      {
        that.dowWxQrCodePay();
      }
    },
    async doWxJsPay()
    {

      let that = this

      if(that.isSubmiting)
      {
        return
      }

      that.isSubmiting = true

      try {
        await that.initWxConfig();
      } catch (_) {
        that.isSubmiting = false;
        that.tipShow = true;
        that.tipType = false;
        that.tipMessage = "微信授权失败";
        setTimeout(() => { that.tipShow = false; }, 1000);
        return;
      }

      let param = {
        year: that.year,
        sub_count: that.sub_count,
        vip_type: that.vip_type
      };

      console.log('param',param)
      wxJsPay(param).then((res) => {
        console.log('wxJsPay',res)
        that.isSubmiting = false
        //{"data":{"return_code":"SUCCESS","return_msg":"OK","result_code":"SUCCESS","mch_id":"1555639731","appid":"wxeec7c320c3eb0477","nonce_str":"QzWx4k1v8wpUFgmV","sign":"736BE6D5CE80892E6377027F6E4BAFC0","prepay_id":"wx13215955111370c9acd376219709f70001","trade_type":"JSAPI","timeStamp":1728827995,"paySign":"EC4BB77F6E090CF824DF6A992C1A521B"}}
        if (res.data.data && res.data.data.result_code == "SUCCESS") 
        {
          var data = res.data.data
          wx.chooseWXPay({
            timestamp: data.timeStamp + '', // 支付签名时间戳
            nonceStr: data.nonce_str + '', // 支付签名随机串，不长于32字节
            package: 'prepay_id=' + data.prepay_id + '',// 统一支付接口返回的 prepay_id 参数值
            signType: 'MD5', // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
            paySign: data.paySign + '', // 支付签名
            success: function(res) {
              // 支付成功的回调
              console.log('支付成功', res);
              that.toPaySuccess();
              
            },
            fail: function(res) {
              // 支付失败的回调
              console.log('支付失败', res);
              //Message.error('微信支付失败');

              that.tipShow = true;
              that.tipType = false;
              that.tipMessage = "微信支付失败";
              setTimeout(() => {
                that.tipShow = false;
              }, 1000);
            }
          });
        }
        else
        {
            //Message.error(res.data.message || res.data.data?.return_msg|| "微信支付失败");
            that.tipShow = true;
            that.tipType = false;
            that.tipMessage = res.data.message || res.data.data?.return_msg|| "微信支付失败";
            setTimeout(() => {
              that.tipShow = false;
            }, 1000);
          }
      })

    },
    doWxH5Pay()
    {
      let that = this

      if(that.isSubmiting)
      {
        return
      }

      that.isSubmiting = true

      let param = {
        year: that.year,
        sub_count: that.sub_count,
        vip_type: that.vip_type
      };

      console.log('param',param)
      wxH5Pay(param).then((res) => {
        console.log('doWxH5Pay',res)
        that.isSubmiting = false
        //{"data":{"return_code":"SUCCESS","return_msg":"OK","result_code":"SUCCESS","mch_id":"1555639731","appid":"wxeec7c320c3eb0477","nonce_str":"QzWx4k1v8wpUFgmV","sign":"736BE6D5CE80892E6377027F6E4BAFC0","prepay_id":"wx13215955111370c9acd376219709f70001","trade_type":"JSAPI","timeStamp":1728827995,"paySign":"EC4BB77F6E090CF824DF6A992C1A521B"}}
        //var strResult = res.data.data;
        //var result = JSON.parse(res.data.data)
        var result = res.data.data
        if (result.h5_url) 
        {
          window.location.href = result.h5_url
        }
        else
        {
          //Message.error(result.message || result?.return_msg || "微信支付失败");
          that.tipShow = true;
          that.tipType = false;
          that.tipMessage = result.message || result?.return_msg || "微信支付失败";
          setTimeout(() => {
            that.tipShow = false;
          }, 1000);
        }
      })
    },
    dowWxQrCodePay()
    {
      let that = this

      if(that.isSubmiting)
      {
        return
      }

      that.isSubmiting = true

      let param = {
        year: that.year,
        sub_count: that.sub_count,
        vip_type: that.vip_type
      };

      console.log('param',param)
      wxQrCodePay(param).then((res) => {
        console.log('wxQrCodePay',res)

        that.isSubmiting = false
        //{"data":{"return_code":"SUCCESS","return_msg":"OK","result_code":"SUCCESS","mch_id":"1555639731","appid":"wxeec7c320c3eb0477","nonce_str":"QzWx4k1v8wpUFgmV","sign":"736BE6D5CE80892E6377027F6E4BAFC0","prepay_id":"wx13215955111370c9acd376219709f70001","trade_type":"JSAPI","timeStamp":1728827995,"paySign":"EC4BB77F6E090CF824DF6A992C1A521B"}}
        if (res.data.data && res.data.data.code_url) 
        {
          that.code_url = res.data.data.code_url
          this.showQrCode();
        }
        else
        {
            // that.tipShow = true;
            // that.tipType = false;
            // that.tipMessage = res.data.data?.return_msg || "微信支付失败";
            // setTimeout(() => {
            //   that.tipShow = false;
            // }, 1000);

            that.tipShow = true;
            that.tipType = false;
            that.tipMessage =  res.data.msg || res.data.message || "微信支付失败";
            setTimeout(() => {
              that.tipShow = false;
            }, 1000);
          }
      })
    },
    showQrCode()
    {
      let that = this
      this.dialogImageVisible = true;
      that.is_showQrcode = 1
      var qrcode = new QRCode('qrcode', {
          width: 320, // 二维码的宽度
          height: 320, // 二维码的高度
          text: that.code_url, // 支付链接
      });
    },
    refreshQrcode()
    {
      let that = this;
      that.disposeQrcode();
      that.dowWxQrCodePay();
    },
    closeQrcode()
    {
      let that = this
      that.is_showQrcode = 0

      that.disposeQrcode();
    },
    disposeQrcode()
    {
      this.code_url = ''
      this.$nextTick(function(){
        let dom = document.getElementById("qrcode");
        while (dom.firstChild) {
          dom.removeChild(dom.firstChild);
        }
      });
    },
    toHelp(id)
    {
      toHelp(id) 
    },
    toLogin()
    {
      toLogin()
    },
    toPaySuccess()
    {
      this.$router.push({
        path: "/paySuccess",
        query: {
        }
      });
    }

  },
  beforeDestroy() {
    if (this.active_timer) {
      clearInterval(this.active_timer);
      console.log('关闭定时器');
    }
  }
};
</script>

<style lang="less" scoped>
  html,
  
  body {
    // height: 100%;
    margin: 0;
    padding: 0;
    overscroll-behavior: none;         /* 禁止多数浏览器回弹 */
    -webkit-overflow-scrolling: auto;  /* 禁止 iOS 惯性滚动和橡皮筋 */
    touch-action: none;                /* 禁止触摸滑动 */
  }

  .pay-page{
    width: 100%;
    height: 100vh;
    height: 100dvh;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
    overflow: hidden;
  }

  .head-v,
  .topDiv-w,
  .bottomDiv-w{
    width: calc(100% - 40px);
    max-width: 700px;
    box-sizing: border-box;
  }

  .topDiv{
    flex: 1;
    min-height: 0;
    padding: 0 0 24px;
    overflow-x: hidden;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
    -ms-overflow-style: none;
    touch-action: pan-y;
  }

    .flex{
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
    }

    .flex-between{
      display: flex;
      flex-direction: row;
      justify-content:space-between;  
    }

    .flex-between-w{
      display: flex;
      flex-direction: column;
      justify-content:space-between;  
    }

    .flex-around{
      display: flex;
      flex-direction: row;
      justify-content:space-around;  
    }
    
    .cursor-pointer{
      cursor: pointer;
    }

    .m-l-30{
      margin-left: 30px;
    }

    .head-v{
      flex: none;
      align-items: center;
      gap: 16px;
      min-height: 76px;
      border-bottom: 1px solid rgba(0,0,0,0.05);
    }

    .logo-img{
      margin-top: 4px;
      width: 36px;
      height: 36px;
      border-radius: 50%;
    }

    .logo-txt
    {
      margin-left: 5px;
      font-size: 28px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: bold;
      color: #000000;
      line-height: 44px;
      text-align: center;
    }

    .logoLogin {
        width: 96px;
        height: auto;
        flex: none;
        display: inline-block;
        vertical-align: middle;
      }

    .user-img
    {
      width: 32px;
      height: 32px;
      flex: none;
      object-fit: cover;
      border-radius: 50%;
    }

    .user-profile{
      min-width: 0;
      max-width: 65%;
      min-height: 48px;
      gap: 10px;
      padding: 0;
      border: 0;
      background: none;
      color: inherit;
      cursor: pointer;
    }

    .user-nv{
      min-width: 0;
      text-align: left;
    }

    .user-nv-name{
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      font-size: 14px;
      font-weight: 600;
      line-height: 20px;
    }

    .user-nv-id{
      display: flex;
      justify-content: flex-start;
      align-items: center;
      gap: 5px;
      color: #8F8F8F;
      font-size: 12px;
      font-weight: 400;
      line-height: 18px;
      white-space: nowrap;
    }

    .user-nv-id svg{
      width: 14px;
      height: 14px;
      flex: none;
    }

    .main-v{
      width: 100%;
    }

    .main-v-1{
      padding: 25px 0 0 0;
    }

    .main-v-t{
      font-size: 18px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: bold;
      color: #000000;
      line-height: 22px;
    }

    .main-v-m{
      margin: 10px 0 0 0;
      font-size: 12px;
      font-family: PingFang SC;
      color:rgba(0,0,0,0.4);
      line-height: 16px;
      text-align: left;
    }

    .main-v-m-r{
      margin: 10px 0 0 0;
      font-size: 12px;
      font-weight: bold;
      font-family: PingFang SC;
      color:#ec4d3d;
      line-height: 16px;
      text-align: left;
    }

    .main-v-nv{
      margin: 15px 0 0 0;
      display: flex;
      flex-direction:row;
      justify-content: space-between;
      align-items: center;
    }

    .main-v-num{
      font-size: 40px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: bold;
      background: linear-gradient(209deg, rgba(213,0,171,0.84) 0%, #FF7952 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      line-height: 50px;
    }

    .main-v-add-img{
      width: 28px;
      height:28px;
    }

    .main-v-add-img:hover{
      opacity: 0.8; 
    }

    .main-v-add-img-1{
      width: 28px;
      height:28px;
      opacity: 0.05;
    }

    .main-v-bv{
      display: flex;
      gap: 12px;
      margin-top: 16px;
    }

    .main-v-btn-w{
      flex: 1;
      min-width: 0;
      min-height: 48px;
      padding: 10px 8px;
      border: 0;
      border-radius: 24px;
      background: rgba(0,0,0,0.05);
      color: rgba(0,0,0,0.2);
      font: inherit;
      font-size: 15px;
      font-weight: 600;
      line-height: 22px;
      text-align: center;
      cursor: pointer;
    }

    .logoLogin2{
      height: 50px;
      opacity: 0.05;
    }

    .main-v-btn-1{
      color: rgba(255,255,255,1);
      background: linear-gradient(209deg, rgba(213,0,171,0.84) 0%, #FF7952 100%);
    }

    .main-v-btn-w:hover {
      opacity: 0.8;
    }

    .main-v-btn-1:hover {
      opacity: 1;
    }

    .pad-btm-v{
      width: 100%;
      // height: calc(84px + constant(safe-area-inset-bottom));
      // height: calc(84px + env(safe-area-inset-bottom));
    }

    .bottomDiv{
      flex: none;
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
    }

    .pay-v{
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;
      margin: 0px 0px 16px 16px;
    }

    .pay-price{
      font-size: 16px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: bold;
      color: #000000;
      text-align: left;
    }
    .pay-price-r{
      font-size: 16px;
      font-family: PingFangSC-Semibold, PingFang SC;
      color: #EC4D3D; 
      font-weight: bold;
      text-align: left;
    }

    .pay-price-o{
      font-size: 16px;
      margin-left: 6px;
      text-decoration: line-through;
      font-weight: bold;
    }

    .pay-memo{
      font-size: 12px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: bold;
      color: #0072FF;
      text-align: left;
      cursor: pointer;
    }

    .pay-btn {
      display: block;
      border: 0;
      padding: 0 16px;
      font-family: inherit;
      font-size: 16px;
      text-align: center;
      height: 50px;
      line-height: 50px;
      color: rgba(255,255,255,1);
      background: linear-gradient(209deg, rgba(213,0,171,0.84) 0%, #FF7952 100%);
      border-radius: 50px;
      width: 100%;
      z-index: 200;
      font-weight: bold;
      cursor: pointer;
    }

    .pay-btn-h{
      background:rgba(0, 0, 0, .05);
      color:rgba(0,0,0, .2);
    }

    .pay-btn:hover {
      opacity: 0.8;
    }

    /* 正文占剩余高度，付款区按真实高度留位，安全区只计算一次。 */
    .topDiv::-webkit-scrollbar,
    .price-detail-drawer::-webkit-scrollbar{
      display: none;
    }

    .bottomDiv-w{
      padding: 16px 0 calc(16px + env(safe-area-inset-bottom));
      background: #fff;
      border-top: 1px solid rgba(0, 0, 0, .05);
    }

    .pay-summary{
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex-wrap: wrap;
      gap: 8px 16px;
    }

    .pay-summary-label{
      color: #000;
      font-size: 14px;
      font-weight: 700;
    }

    .pay-summary-discount{
      margin-top: 3px;
      color: #EC4D3D;
      font-size: 11px;
    }

    .pay-summary-amount{
      color: #EC4D3D;
      font-size: 25px;
      font-weight: 700;
      line-height: 1;
      text-align: right;
      white-space: nowrap;
    }

    .pay-price-o{
      display: inline-block;
      margin-right: 7px;
      color: rgba(0, 0, 0, .35);
      font-size: 12px;
      font-weight: 400;
      text-decoration: line-through;
    }

    .pay-links{
      display: flex;
      gap: 10px;
      margin-top: 12px;
    }

    .pay-link{
      flex: 1;
      min-width: 0;
      min-height: 44px;
      padding: 9px 0;
      border: 1px solid rgba(0, 0, 0, .08);
      border-radius: 9px;
      background: #fff;
      color: #0072FF;
      cursor: pointer;
      font-size: 13px;
      font-weight: 700;
      line-height: 18px;
      text-align: center;
    }

    .bottomDiv .pay-btn,
    .price-detail-pay{
      box-sizing: border-box;
      height: 50px;
      margin-top: 12px;
      line-height: 50px;
    }

    .price-detail-mask{
      position: fixed;
      z-index: 300;
      top: 0;
      left: 0;
      display: flex;
      align-items: flex-end;
      width: 100vw;
      height: 100vh;
      background: rgba(0, 0, 0, .48);
      color: #000;
      font-family: PingFang SC, PingFangSC-Regular, sans-serif;
    }

    .price-detail-drawer{
      box-sizing: border-box;
      width: 100%;
      max-height: 88vh;
      overflow-y: auto;
      padding: 20px 20px calc(20px + env(safe-area-inset-bottom));
      background: #fff;
      border-radius: 20px 20px 0 0;
      -webkit-overflow-scrolling: touch;
      scrollbar-width: none;
      -ms-overflow-style: none;
    }

    .price-detail-status{
      padding: 14px;
      border-radius: 14px;
      background: linear-gradient(209deg, rgba(213, 0, 171, .84) 0%, #FF7952 100%);
      color: #fff;
    }

    .price-detail-status-label{
      font-size: 12px;
      opacity: .78;
    }

    .price-detail-expire{
      margin-top: 4px;
      font-size: 22px;
      font-weight: 700;
      line-height: 1.15;
    }

    .price-detail-benefit{
      margin-top: 6px;
      font-size: 12px;
      font-weight: 400;
      opacity: .86;
    }

    .price-detail-status-meta{
      display: flex;
      gap: 10px;
      margin-top: 12px;
      padding-top: 10px;
      border-top: 1px solid rgba(255, 255, 255, .25);
      font-size: 12px;
      opacity: .82;
    }

    .price-detail-status-meta > div{
      flex: 1;
    }

    .price-detail-status-meta strong{
      display: block;
      margin-top: 3px;
      color: #fff;
      font-size: 14px;
      opacity: 1;
    }

    .price-detail-groups{
      margin-top: 30px;
    }

    .price-detail-group + .price-detail-group{
      margin-top: 30px;
    }

    .price-detail-group h3,
    .price-detail-total h3{
      margin: 0;
      color: #000;
      font-size: 14px;
      font-weight: 700;
      line-height: 1.2;
    }

    .price-detail-row{
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      gap: 10px;
      margin-top: 4px;
      color: rgba(0, 0, 0, .4);
      font-size: 11px;
      line-height: 1.2;
    }

    .price-detail-row span{
      flex: 1;
      min-width: 0;
    }

    .price-detail-row strong{
      color: #000;
      font-weight: 400;
      white-space: nowrap;
    }

    .price-detail-discounts .price-detail-row,
    .price-detail-discounts .price-detail-row strong{
      color: #EC4D3D;
    }

    .price-detail-total{
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 16px;
      margin-top: 30px;
      padding-top: 12px;
      border-top: 1px solid rgba(0, 0, 0, .05);
    }

    .price-detail-total p{
      margin: 3px 0 0;
      color: #EC4D3D;
      font-size: 11px;
    }

    .price-detail-total > strong{
      color: #EC4D3D;
      font-size: 25px;
      font-weight: 700;
      line-height: 1;
      white-space: nowrap;
    }

    .price-detail-pay{
      margin-top: 16px;
    }

    .load-txt{
      width: 100%;
      height: 100vh;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }

    .qrcode-bg{
      position: fixed;
      z-index: 100;
      left: 0;
      top: 0;
      width: 100vw;
      height: 100vh;
      background: rgba(0,0,0,0.9);
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }
    
    .qrcode-v{
      position: fixed;
      z-index: 200;
      width: 400px;
      height: 500px;
      margin-bottom: 50px;
      background: rgba(255,255,255,1);
      border-radius: 20px;
      display: flex;
      flex-direction: column;
      align-items: center;
    }

    .qrcode-img{
      width: 80%;
      margin: 40px 0 0 0px;
      display: flex;
      justify-content: center;
    }

    .qrcode-memo{
      position: absolute;
      bottom: 70px;
      font-size:24px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: bold;
      color:rgba(0,0,0,1);
      text-align: center;
    }

    .qrcode-ref{
      position: absolute;
      bottom: 40px;
      font-size: 14px;
      font-weight: bold;
      color: #0072FF;
      cursor: pointer;
    }

    
    .generalTip1 {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      display: flex;
      flex-direction:column;
      justify-content: center;
      align-items: center;
      z-index: 1009;

      .generalTip {
      position: fixed;
      padding: 0 30px;
      height: 50px;
      line-height: 50px;
      border-radius: 50px;
      top: 20px;
      color: #ffffff;
      font-size: 16px;
      text-align: center;
      }

      .generalTip_r {
      background: #ec4d3d;
      }

      .generalTip_b {
      background: #000;
    }
}


</style>
